import axios from "axios";
import { BACKEND_URL } from "../backendURL";



class VHPService {

    getMyVoters(token, filters) {
        const searchFilters = filters.searchFilters;
        const pagination = filters.pagination;
        const limit = pagination.pageSize;
        const offset = pagination.pageSize * (pagination.currentPage - 1);
        const params = { ...searchFilters, offset: offset, limit: limit };

        const config = {
            headers: {
                'Authorization': "Token " + token
            },
            params: params
        };

        const apiUrl = BACKEND_URL + "/api/patronage/my-ftv-voters/";
        return axios.get(apiUrl, config);
    };


    updatePreference(token, data, voterId) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const apiUrl = BACKEND_URL + "/api/patronage/set-ftv-voter-preference/" + voterId + "/";
        return axios.put(apiUrl, data, config);
    };

}

export default new VHPService();